var map = {
	"./home/claim.png": 3894,
	"./home/claim.svg": 8207,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./main.scss": 4235,
	"./navigation/background.webp": 4952,
	"./standort/lokal.webp": 3596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;